(function () {
  if (window.__kgGreatRefreshBound) return;
  window.__kgGreatRefreshBound = true;

  function cartAddUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function setError(btn, message) {
    var scope = btn.closest('.gr-up__card') || btn.closest('.gr-page__level') || btn.parentElement;
    var box = scope ? scope.querySelector('.js-great-refresh-error') : null;
    if (!box) return;
    if (!message) {
      box.hidden = true;
      box.textContent = '';
      return;
    }
    box.hidden = false;
    box.textContent = message;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('.js-great-refresh-add') : null;
    if (!btn) return;
    evt.preventDefault();

    if (btn.getAttribute('aria-disabled') === 'true') return;
    setError(btn, '');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    var qty = parseInt(btn.dataset.quantity, 10);
    if (!qty || qty < 1) qty = 1;
    var item = { id: parseInt(btn.dataset.variantId, 10), quantity: qty };
    if (btn.dataset.covers) item.properties = { Covers: btn.dataset.covers };

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.data.description || res.data.message || 'This could not be added to your cart.');
        }
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.removeAttribute('aria-disabled');
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: item.id } }));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        if (btn.dataset.openDrawer === 'true' && document.querySelector('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.remove('is-success');
        btn.removeAttribute('aria-disabled');
        setError(btn, err.message);
      });
  });

  function postJson(path, body) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Your cart could not be updated.');
        return data;
      });
    });
  }

  function settleQuantities(updates, attempt) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return postJson('cart/update.js', { updates: updates })
      .then(function () {
        return new Promise(function (resolve) {
          setTimeout(resolve, 700);
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        var pending = {};
        Object.keys(updates).forEach(function (key) {
          var qty = 0;
          cart.items.forEach(function (line) {
            if (line.key === key) qty = line.quantity;
          });
          if (qty !== updates[key]) pending[key] = updates[key];
        });
        if (!Object.keys(pending).length) return;
        if (attempt >= 2) throw new Error('Your cart could not be updated. Refresh the page and check your cart.');
        return settleQuantities(pending, attempt + 1);
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('.js-great-refresh-swap') : null;
    if (!btn) return;
    evt.preventDefault();

    if (btn.getAttribute('aria-disabled') === 'true') return;
    var plan;
    try {
      plan = JSON.parse(btn.dataset.swap || '[]');
    } catch (e) {
      plan = [];
    }
    if (!plan.length) return;

    setError(btn, '');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        var adds = [];
        plan.forEach(function (step) {
          var left = step.qty;
          cart.items.forEach(function (line) {
            if (left < 1 || line.variant_id !== step.from) return;
            var take = Math.min(left, line.quantity);
            updates[line.key] = line.quantity - take;
            left -= take;
          });
          var moved = step.qty - left;
          if (moved > 0) {
            var add = { id: step.to, quantity: moved };
            if (step.covers) add.properties = { Covers: step.covers };
            adds.push(add);
          }
        });
        if (!adds.length) throw new Error('Your cart has changed. Refresh the page and try again.');
        return postJson('cart/add.js', { items: adds }).then(function () {
          return settleQuantities(updates, 0);
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        setError(btn, err.message);
      });
  });

  function syncColorField() {
    var level = document.getElementById('gr_level');
    var color = document.getElementById('gr_color');
    if (!level || !color) return;
    var needsColor = level.value.indexOf('Level 2') === 0 || level.value.indexOf('Level 3') === 0;
    color.required = needsColor;
    var label = document.querySelector('label[for="gr_color"]');
    if (label) {
      label.textContent = needsColor ? 'Cerakote color code' : 'Cerakote color code, for Levels 2 and 3';
    }
  }

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.id === 'gr_level') syncColorField();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncColorField);
  } else {
    syncColorField();
  }
})();
